import { HttpClient, HttpRequest, HttpResponse } from '@/javascript/data/protocols/http';

export class CurrentAccountHttpClientDecorator implements HttpClient {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly currentAccount: { id: number }
  ) {}

  async request(data: HttpRequest): Promise<HttpResponse> {
    const account = this.currentAccount
    if (account?.id) {
      data.params = Object.assign(data.params || {}, {
        account_id: account.id
      })
    }
    const httpResponse = await this.httpClient.request(data)
    return httpResponse
  }
}
